import { InstrumentModel } from '@javascript/habitual-analytics/models/instrument/types';
import _ from 'lodash';
import {
  Exchanges, OptionTypes, Segments
} from '@javascript/habitual-analytics/brokers/OrderFacade/types/common';
import { TradingSymbol } from '@javascript/habitual-analytics/brokers/OrderFacade/types/TradingSymbol';

export const formatTradingSymbol = (instrument: InstrumentModel): TradingSymbol => {
  const exchange = instrument.getExchangeSegment();
  if (instrument.isOption()) {
    const [year, month, date] = _.get(instrument, 'expiryDate', '').split('-');
    return {
      exchange: Exchanges[exchange],
      instrument: _.get(instrument, 'symbol', ''),
      segment: Segments.OPT,
      expiry: {
        year: Number(year?.slice(-2)),
        month: Number(month),
        date: Number(date),
      },
      strikePrice: _.get(instrument, 'strikePrice', 0),
      optionType: _.get(instrument, 'optionType', '') === 'CE' ? OptionTypes.CE : OptionTypes.PE,
    };
  } else if (instrument.isFuture()) {
    const [year, month, date] = _.get(instrument, 'expiryDate', '').split('-');
    return {
      exchange: Exchanges[exchange],
      instrument: _.get(instrument, 'symbol', ''),
      segment: Segments.FUT,
      expiry: {
        year: Number(year?.slice(-2)),
        month: Number(month),
        date: Number(date),
      },
    };
  }
  return {
    exchange: Exchanges[exchange],
    instrument: _.get(instrument, 'symbol', ''),
    segment: Segments.EQ
  };
};